import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';

@Component({
  selector: 'app-help-center',
  templateUrl: './help-center.component.html',
  styleUrls: ['./help-center.component.css']
})
export class HelpCenterComponent {
  constructor(private http: HttpClient) {
    this.http.get<[]>
      ("./assets/menu.json")
      .subscribe((settings) => this.menuList = settings);
  }

  public menuList: any;

  public onClick(){
    alert(`hello`);
  }
}
